const removeFieldName = message => {
  if (typeof message !== "string") {
    return message;
  }

  const lines = message.split("\n");
  const cleanedLines = lines
    .map(line => {
      let trimmed = line.trim();
      if (!trimmed) return "";

      // Remove leading bullets or list dashes
      trimmed = trimmed.replace(/^[-*•]\s*/, "");
      // Remove optional ERROR: prefix
      trimmed = trimmed.replace(/^ERROR:\s*/i, "");

      // Match common field name prefixes:
      // e.g. "bankAccountHuf: ", "supplier.bankAccountHuf: ", "customer[0].bankAccountEur: ",
      // "factorDataSheet.bankAccountUsd - ", "children[supplier].children[bankAccountHuf]: "
      const fieldPrefixRegex = /^(?:['"([])?[a-zA-Z0-9_]+(?:(?:\.|->)[a-zA-Z0-9_]+|\[[a-zA-Z0-9_'"\][]+)*['")\]]?\s*(?::\s*-\s*|:\s*|-\s+)/;

      let cleaned = trimmed.replace(fieldPrefixRegex, "").trim();

      // In case of multiple nested prefixes (e.g. "supplier: bankAccountHuf: ...")
      while (fieldPrefixRegex.test(cleaned)) {
        const next = cleaned.replace(fieldPrefixRegex, "").trim();
        if (next === cleaned) break;
        cleaned = next;
      }

      // If the field name is directly mentioned at the start without colon or with loose separator
      cleaned = cleaned
        .replace(
          /^(?:supplier\.|factorDataSheet\.)?(?:bankAccountHuf|bankAccountEur|bankAccountUsd)\s*[:\-]?\s*/i,
          ""
        )
        .trim();

      // Capitalize first character if lowercase
      if (cleaned.length > 0) {
        cleaned = cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
      }

      return cleaned;
    })
    .filter(Boolean);

  const result = cleanedLines.join("\n");
  return result || message;
};

export default removeFieldName;
